/**
 * A `run-command` line as its words, split the way fleet-agent's CLI splits it
 * (`src/domain/fleet/run-command.ts`, ADR 0016): whitespace splits, and '…' or
 * "…" keep one word whole. Only the split — whether the words may run is
 * `FleetCommandBodySchema`'s call, the same check the backend and the host make.
 */
export type SplitCommandLine =
  { readonly ok: true; readonly argv: readonly string[] } | { readonly ok: false; readonly unclosedQuote: '"' | "'" };

export function splitCommandLine(line: string): SplitCommandLine {
  const words: string[] = [];
  let word = '';
  let inWord = false;
  let quote: '"' | "'" | undefined;

  for (const char of line) {
    if (quote !== undefined) {
      if (char === quote) quote = undefined;
      else word += char;
    } else if (char === '"' || char === "'") {
      quote = char;
      inWord = true;
    } else if (/\s/.test(char)) {
      if (inWord) words.push(word);
      word = '';
      inWord = false;
    } else {
      word += char;
      inWord = true;
    }
  }

  if (quote !== undefined) return { ok: false, unclosedQuote: quote };

  if (inWord) words.push(word);

  return { ok: true, argv: words };
}

/** The argv as a person would type it again — fleet-agent's `formatCommandLine`. */
export function formatCommandLine(argv: readonly string[]): string {
  return argv.map((word) => (word === '' || /[\s'"]/.test(word) ? `'${word.replaceAll("'", '"')}'` : word)).join(' ');
}
